import { render } from "./g-loader2.vue?vue&type=template&id=59e3abb2&ts=true"
import script from "./g-loader2.vue?vue&type=script&lang=tsx"
export * from "./g-loader2.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__